if (!customElements.get('coming-soon-form')) {
  const KLAVIYO_COMPANY_ID = 'Q4Qf7q';
  const GENERIC_ERROR_MESSAGE = 'There was an error. Please try again.';

  /**
   *  @class
   *  @function ComingSoonForm
   */
  class ComingSoonForm extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('.klaviyo-coming-soon-form');
      this.responseElement = this.querySelector('.coming-soon-response');
      this.emailInput = this.querySelector('input[name="contact[email]"]');
      this.labelElement = this.querySelector('.field__label');

      if (!this.form || !this.responseElement || !this.emailInput) {
        return;
      }

      this.isComingSoon = this.dataset.comingSoon === 'true';
      this.activeVariantId = `$shopify:::$default:::${this.dataset.variantId}`;

      document.addEventListener('product:variant-change', this.onVariantChange);
      this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariantChange);
      this.form?.removeEventListener('submit', this.onSubmit);
    }

    onVariantChange(evt) {
      if (evt?.detail?.sectionId !== this.dataset.sectionId || !evt?.detail?.variant?.id) {
        return;
      }
      this.activeVariantId = `$shopify:::$default:::${evt.detail.variant.id}`;
    }

    onSubmit(e) {
      e.preventDefault();

      const url = this.isComingSoon
        ? `https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_COMPANY_ID}`
        : `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`;
      const payload = this.isComingSoon ? this.comingSoonPayload() : this.backInStockPayload();

      fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Revision: '2024-06-15'
        },
        body: JSON.stringify(payload)
      })
        .then((response) => {
          if (response.status === 202) {
            this.showResponseMessage('Thank you! We will notify you when this product becomes available.');
            return;
          }

          return response.json()
            .then((data) => {
              const apiError = data?.errors?.[0];
              this.showResponseMessage(apiError?.detail || apiError?.title || GENERIC_ERROR_MESSAGE);
            })
            .catch((error) => {
              console.warn('[coming-soon-form] failed to parse Klaviyo response', error);
              this.showResponseMessage(GENERIC_ERROR_MESSAGE);
            });
        })
        .catch((error) => {
          console.warn('[coming-soon-form] Klaviyo request failed', error);
          this.showResponseMessage(GENERIC_ERROR_MESSAGE);
        });

      this.handleFormUI();
    }

    comingSoonPayload() {
      let collections = [];
      try {
        collections = JSON.parse(this.dataset.collections || '[]');
      } catch (error) {
        console.warn('[coming-soon-form] failed to parse data-collections', this.dataset.collections, error);
      }

      return {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Coming Soon Subscription' } } },
            profile: { data: { type: 'profile', attributes: { email: this.emailInput.value } } },
            properties: {
              product_id: this.dataset.productId,
              product_handle: this.dataset.productHandle,
              collection: collections
            }
          }
        }
      };
    }

    backInStockPayload() {
      return {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: this.emailInput.value } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: this.activeVariantId } }
          }
        }
      };
    }

    showResponseMessage(message) {
      this.responseElement.style.display = 'block';
      this.responseElement.innerText = message;
    }

    handleFormUI() {
      if (this.labelElement) {
        this.labelElement.style.display = 'none';
      }
      this.emailInput.style.backgroundColor = '#F9F8F7';
    }
  }
  customElements.define('coming-soon-form', ComingSoonForm);
}
